import ErrorBoundary from '@ms/yammer-libs-error-boundary';
import type { FC } from 'react';
import React, { memo } from 'react';

import PageTelemetryContextProvider from '../PageTelemetryContextProvider';

import AppPageRoutesWithTelemetry from './AppPageRoutesWithTelemetry';
import type { AppPageRoutesWithTelemetryProps } from './AppPageRoutesWithTelemetry.types';

const AppPageRoutesWithTelemetryBoundary: FC<AppPageRoutesWithTelemetryProps> = (props) => (
  <ErrorBoundary name="AppPageRoutesWithTelemetry">
    <PageTelemetryContextProvider>
      <AppPageRoutesWithTelemetry {...props} />
    </PageTelemetryContextProvider>
  </ErrorBoundary>
);

export default memo(AppPageRoutesWithTelemetryBoundary);
